module.exports = __webpack_public_path__ + "img/gi_tuangsewarna.2982cbba.png";